import React, { useContext } from 'react';

import {
    RemoveStructuredBriefDesigners as RemoveStructuredBriefDesignersMutationInterface,
    RemoveStructuredBriefDesignersVariables,
} from '__generated__/RemoveStructuredBriefDesigners';
import { DesignerSource } from '__generated__/types';
import BriefContext from 'projects/components/BriefContext';
import { Mutation, MutationFetchResult, MutationResult } from 'react-apollo';
import mutation from './RemoveStructuredBriefDesigners.graphql';

interface Props {
    children: (
        removeStructuredBriefDesigners: (
            variables: RemoveStructuredBriefDesignersVariables
        ) => Promise<void | MutationFetchResult<RemoveStructuredBriefDesignersMutationInterface>>,
        result: MutationResult
    ) => React.ReactElement;
}

const RemoveStructuredBriefDesigners = ({ children }: Props) => {
    const { brief } = useContext(BriefContext);

    return (
        <Mutation<
            RemoveStructuredBriefDesignersMutationInterface,
            RemoveStructuredBriefDesignersVariables
        >
            mutation={mutation}
        >
            {(mutation, result) => {
                return children(variables => {
                    const dws = brief.designers.map((d, i) => ({
                        ...d,
                        source: brief.designersWithSource[i].source,
                    }));

                    return mutation({
                        variables,
                        optimisticResponse: dws
                            ? ({
                                  removeStructuredBriefDesigners: {
                                      id: variables.id,
                                      __typename: 'StructuredBrief',
                                      designers: dws
                                          .filter(d => variables.designerIds.indexOf(d.id) < 0)
                                          .map(d => ({
                                              id: d.id,
                                              __typename: 'User',
                                          })),
                                      designersWithSource: dws
                                          .slice()
                                          .filter(d => variables.designerIds.indexOf(d.id) < 0)
                                          .map(d => ({
                                              __typename: 'DesignerWithSource',
                                              source: d.source as DesignerSource,
                                          })),
                                  },
                              } as RemoveStructuredBriefDesignersMutationInterface)
                            : undefined,
                    });
                }, result);
            }}
        </Mutation>
    );
};

export default RemoveStructuredBriefDesigners;
